// Lib Imports
import * as React from 'react';
import { Box, Grid, Text } from 'grommet';
import PropTypes from 'prop-types';
export const RowSubComponent = /*#__PURE__*/React.memo(({
  row,
  tableProps,
  tableState,
  className
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    pad: "medium",
    gap: "small",
    width: "100%",
    className: className
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    weight: "bold"
  }, "Details ", row.values.pk ? `(ID: ${row.values.pk})` : ''), /*#__PURE__*/React.createElement(Grid, {
    columns: ['flex', 'flex'],
    gap: "small"
  }, Object.entries(row.values).map(([key, value]) => {
    if (['actions', 'selection', 'utils', 'pk'].includes(key)) return null;
    return /*#__PURE__*/React.createElement(Box, {
      key: key,
      direction: "row",
      gap: "medium"
    }, /*#__PURE__*/React.createElement(Text, {
      weight: "bold"
    }, key, ":"), /*#__PURE__*/React.createElement(Text, null, typeof value === 'object' ? JSON.stringify(value) : value));
  })));
});
RowSubComponent.displayName = 'RowSubComponent';
RowSubComponent.propTypes = {
  row: PropTypes.object,
  tableProps: PropTypes.object,
  tableState: PropTypes.object,
  className: PropTypes.string
};